import { Component, OnInit } from '@angular/core';
import { PanelCiudadano } from '../../../../../_entities/panelCiudadano/panelCiudadano';
import { PanelAdministracionService } from '../../../../panel-vigilancia/services/panel-administracion.service';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material';
import { MapaService } from '../../../services/mapa.service';
import { HistoricoPanelComponent } from '../../popups/paneles/historico-panel/historico-panel.component';

@Component({
  selector: 'kt-boton-ciudadano',
  templateUrl: './boton-ciudadano.component.html',
  styleUrls: ['./boton-ciudadano.component.scss']
})
export class BotonCiudadanoComponent implements OnInit {
  public paneles: PanelCiudadano[];
	public applyFilterTypes: any;
	public currentFilter: any;
	public showFilterRow: boolean;
	public showHeaderFilter: boolean;
	 isDiabled: boolean = true;
	public datosReporte = [];

  constructor(private mapaService:MapaService,private panelService:PanelAdministracionService,public dialogRef: MatDialogRef<BotonCiudadanoComponent>,
		public dialog: MatDialog) { 
      this.showFilterRow = true;
      this.showHeaderFilter = true;
    }

  ngOnInit(): void {
    this.obtenerPaneles();
  }

  obtenerPaneles(){
    this.panelService.obtenerPaneles().subscribe((result:PanelCiudadano[])=>{
      this.paneles = result;

      this.paneles.forEach(panel => {
        this.datosReporte.push({
          'Nombre':panel.nombre,
          'Modelo':panel.modelo,
          'Número Seríe':panel.numeroSerie,
          'Descripción':panel.descripcion,
          'Nombre Contacto': panel.nombreContacto,
          'Teléfono Contacto': panel.telefonoContacto,
          'Código Protocolo': panel.codigoProtocolo
        });
      });
      if(this.datosReporte.length > 0) {
        this.isDiabled = false;
      }
    })
  }

  public minimizarPopup() {
		this.dialogRef.addPanelClass('displayNone');
	}

	public maximizarPopup() {
		this.dialogRef.removePanelClass('displayNone');
	}

	public cerrarPopup() {
		this.dialogRef.close();
	}
	ubicarPuntoHistorico(data) {
		this.mapaService.ocultarUbicadorPanelesLayer();
		this.dialogRef.close();
		this.mapaService.verPanel(data);
	}

  historicoPanel(data){
    const dialogConfig = new MatDialogConfig();
		dialogConfig.autoFocus = true;
		dialogConfig.disableClose = true;
		dialogConfig.hasBackdrop = false;
		dialogConfig.width = "58%";
		dialogConfig.data = data;
		this.dialogRef.close();
		this.dialog.open(HistoricoPanelComponent, dialogConfig);
  }

}
